import React, { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Card, createTheme } from "@mui/material";
import { ThemeProvider, StyledEngineProvider } from "@mui/material";
import Grid from "@mui/material/Grid";
import Navbar from "routes/app/routes/Schedule/ScheduleNavbar";
import { useDispatch, useSelector } from "react-redux";

import {
  scheduledataSelector,
  scheduledata_setToday,
  scheduledata_setCurrentWeekNumber,
  scheduledata_fetchData
} from "reducers/scheduledata/scheduledata";

import {
  orderdataSelector,
  orderdata_fetchData
} from "reducers/orderdata/orderdata";
import { fetchData, menudataSelector } from "reducers/menudata/menudata";
import {
  todayLocaleDateString,
  calculateCurrentWeek
} from "routes/app/routes/Schedule/ScheduleHelper";
import GroupOrdersWeek from "./GroupOrdersWeek";
const defaultMaterialTheme = createTheme({
  palette: {
    primary: {
      main: "#008752"
    }
  },
  backdrop: {
    zIndex: 9999999,
    color: "#000"
  }
});

function GroupOrders(props) {
  const dispatch = useDispatch();
  const scheduledata = useSelector(scheduledataSelector);
  const orderdata = useSelector(orderdataSelector);
  const menudata = useSelector(menudataSelector);

  useEffect(() => {
    // once on load
    console.log("GroupOders - init");

    if ((menudata && !menudata.loaded) || menudata.needsUpdate) {
      console.log("should go get data");
      dispatch(fetchData());
    }

    if (!scheduledata.today) {
      // go get today
      // go get today
      // go get today
      let today = todayLocaleDateString();
      dispatch(scheduledata_setToday(today));
    }

    if (!scheduledata.currentWeekNumber) {
      // set number of current week
      // set number of current week
      // set number of current week
      let currentweeknumber = calculateCurrentWeek();
      dispatch(scheduledata_setCurrentWeekNumber(currentweeknumber));
    }



  }, []);

  useEffect(() => {
    // watch the scheduledata
    if (
      scheduledata.currentWeekNumber &&
      !Object.keys(scheduledata.menus).includes(
        String(scheduledata.selectedWeekNumber)
      )
      && !scheduledata.errorMessage
    ) {
      console.log("schedule should go fetch current week");
      dispatch(scheduledata_fetchData(scheduledata.selectedWeekNumber));
    } else {
      console.log("schedule, current week number already present in store");
    }

    if (
      !orderdata.ordersForGroups.hasOwnProperty(scheduledata.selectedWeekNumber) &&
      !orderdata.loading
    ) {
      dispatch(orderdata_fetchData(true, scheduledata.selectedWeekNumber));
    }
  }, [scheduledata]);


  useEffect(() => {

    // watch the orders for groups
    // if updated, see if any new group orders are created
    // and scroll to that element in the view
    let newGroupOrder = document.getElementById('newGroupOrder');
    if (newGroupOrder) {
      newGroupOrder.scrollIntoView();
    }

  }, [orderdata.ordersForGroups]);



  return (
    <Grid
      className="mt-2"
      container
      spacing={2}
      alignItems="top"
      justifyContent="center"
      style={{ minHeight: "100vh" }}
    >
      <Grid item xs={12} md={10}>
        <StyledEngineProvider injectFirst>
          <ThemeProvider theme={defaultMaterialTheme}>
            <Card>
              <article className="article">
                <div className="container-fluid no-breadcrumb chapter FormIntegration">
                  <Grid container justify="space-between">
                    <Grid item xs={12} sm={6}>
                      <h2 className="article-title">Group Orders</h2>
                    </Grid>
                    <Grid item xs={12} sm={6} className="text-sm-right">
                      <h2 className="article-title">
                        Today: {scheduledata.today}
                      </h2>
                    </Grid>
                    Place or update custom orders for groups.
                  </Grid>
                  <div className="mt-4 mb-4">
                    <Navbar></Navbar>
                  </div>
                </div>
              </article>
            </Card>
            <div className="mt-2">
              <GroupOrdersWeek></GroupOrdersWeek>
            </div>

            <Card className="mt-4 d-none">
              <article className="article">
                <div className="container-fluid no-breadcrumb chapter FormIntegration">
                  <div>
                    <h2 className="article-title mb-4">Todo's</h2>
                    <ul>
                      <li>
                        <b>a lot</b>
                      </li>
                    </ul>
                  </div>
                </div>
              </article>
            </Card>
          </ThemeProvider>
        </StyledEngineProvider>
      </Grid>
    </Grid>
  );
}

export default GroupOrders;
